module.exports = __webpack_public_path__ + "ff9cb1e83fd7a9ee6c7e34f43b9a85e4.jpg";